export default {
  label: {
    insertImage: 'Insert image',
    insertFile: 'Insert file',
    insertLink: 'Insert image link',
    link: 'Link',
    cancel: 'Cancel',
    select: 'Select',
  },
};
